import { PropertyMapper } from '../../decorators';

export class LotType {

    @PropertyMapper()
    id: number;

    @PropertyMapper()
    name: string;
}
